<template lang="html">
  <div class="password-form">
    <h1>Reset Password</h1>

    <form @submit.prevent="submit" v-if="!this.resetting">
      <Field
        label="Email address"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"/>

      <div class="form-actions">
        <Btn primary :isLoading="btnLoading">Reset Password</Btn>
      </div>
    </form>

    <span class="password-notice" v-if="this.resetting">
      Please reset your password by clicking on the link we've just emailed to you.
    </span>
  </div>
</template>

<script>
import form from '@/mixins/form'

import {errorMessages} from '@/lib/error_messages'
import {required, email} from 'vuelidate/lib/validators'

import Btn from '@/components/Btn'

export default {
  name: 'password-email-form',

  mixins: [form],

  props: {
    btnLoading: Boolean,
    resetting: Boolean
  },

  components: {
    Btn
  },

  computed: {
    ...errorMessages(['email'])
  },

  validations: {
    resource: {
      email: {required, email}
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

$password-form-width: 50%

.password-form
  margin: auto
  @extend %card
  padding: $gap-x-large
  border-radius: 5px
  max-width: 95%

  @include media($media-gt-small)
    width: $password-form-width

  .password-notice
    font-size: 14px
    text-align: center
    display: block
    margin-top: $gap-medium
    color: $color-success
    font-weight: bold

  h1
    margin: 0 auto $gap-large

  input
    width: 100%

  .form-actions
    text-align: center

    .btn
      display: block
      margin: 0 auto $gap-small
</style>
